import * as React from 'react'
import './index.scss'
import { connect } from "react-redux";
import { ActionType, orderFilterType, reducerStoreType, settlementsStateType } from "../../reducers/types";
import { Dispatch } from "redux";
// import Pagination from "../../components/Pagination";
import SettlementFilters from './SettlementFillters'
import SettlementsList from "./SettlementsList";
import Pagination from "../../components/Pagination";

interface IProps extends settlementsStateType {
  dispatch: Dispatch<ActionType<any>>,
  orgCurrency: string,
  currency: string
}
class Settlements extends React.Component<IProps, {}> {
  handleFilterChange = (filters: orderFilterType) => {
    this.props.dispatch({ type: 'SETTLEMENT_FILTER_CHANGE', payload: filters })
  }
  onConfirm = () => {
    this.props.dispatch({ type: 'GET_SETTLEMENTS', payload: { pageParams: { currentPage: 1 } } })
  }
  onClear = () => {
    this.props.dispatch({ type: 'CLEAR_SETTLEMENT_FILTER', payload: undefined })
    this.props.dispatch({ type: 'GET_SETTLEMENTS', payload: { pageParams: { currentPage: 1 } } })
  }
  onPageChange = (page: number) => {
    this.props.dispatch({ type: 'GET_SETTLEMENTS', payload: { pageParams: { currentPage: page } } })
  }
  onRecordsPerPageChange = (value: number) => {
    this.props.dispatch({ type: 'GET_SETTLEMENTS', payload: { pageParams: { currentPage: 1, recordsPerPage: value } } })
  }
  onExport = () => {
    this.props.dispatch({ type: 'GET_SETTLEMENTS', payload: { type: 'export' } })
  }
  public render() {
    return (
      <div className="settlements">
        <SettlementFilters filters={this.props.filters}
          onExport={this.onExport}
          handleFilterChange={this.handleFilterChange}
          onClear={this.onClear}
          onConfirm={this.onConfirm}
        />
        <SettlementsList list={this.props.list}
          currency={this.props.currency}
          orgCurrency={this.props.orgCurrency} />
        <Pagination total={this.props.total}
          currentPage={this.props.currentPage}
          recordsPerPage={this.props.recordsPerPage}
          onPageChange={this.onPageChange}
          onRecordsPerPageChange={this.onRecordsPerPageChange} />
      </div>
    );
  }
}

export default connect((state: reducerStoreType) => {
  return {
    ...state.settlements,
    orgCurrency: state.merchant.merchantInfo.orgCurrency,
    currency: state.merchant.merchantInfo.currency
  }
})(Settlements)
